import { Action, createReducer, on } from '@ngrx/store';
import { IInviteStatus } from '../models/invite-status.model';
import * as actions from '../actions';

export const inviteStatusFeatureKey = 'inviteStatus';

export interface InviteStatusState {
  loadInviteStatusResponse: IInviteStatus[];
}

export const initialState: InviteStatusState = {
  loadInviteStatusResponse: undefined
};

export const reducer = createReducer(
  initialState,

  on(actions.loadInviteStatusSuccess, (state, action) => ({
    ...state,
    loadInviteStatusResponse: action.response
  }))
);

export const getInviteStatus = (state: InviteStatusState) => state.loadInviteStatusResponse;
